import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Home } from '../Pages/Home';

export function Routes(): React.ReactElement {
  return (
    <Switch>
      <Redirect exact from="/letters" to="/" />
      <Route path="/" exact component={Home} />
    </Switch>
  );
}
